"use client";

import React from "react";
import { usePathname } from "next/navigation";

export const BackgroundLines = React.memo(() => {
  const pathname = usePathname();
  const isAdminPage = pathname.startsWith("/sachinsharma/official/adminpanel");

  if (isAdminPage) return null;

  return (
    <div className="fixed inset-0 z-[-1] pointer-events-none h-full w-full bg-background flex justify-center">
      {/* Clean, subtle grid with larger spacing - only visible in dark mode */}
      <div className="absolute inset-0 h-full w-full bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#80808018_1px,transparent_1px),linear-gradient(to_bottom,#80808018_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      {/* Soft vignette to fade out edges and focus attention */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_50%_200px,transparent,var(--background))]"></div>
    </div>
  );
});

BackgroundLines.displayName = "BackgroundLines";
